module.exports = __webpack_public_path__ + "img/horizontal-logo.fb7a5076.svg";